<template>

    <span 
      v-if="tableParameter[tableParameterIndex].index"
      v-on:click="onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex)">
      {{ tableData[tableDataIndex]['jt-summary'] ? '' : (((tablePage - 1) * 100) + tableDataIndex + 1) }}
    </span>
    <component 
      v-else-if="tableParameter[tableParameterIndex].table_component" 
      v-bind:is="tableParameter[tableParameterIndex].table_component"
      v-bind:tableData="tableData" 
      v-bind:tableDataIndex="tableDataIndex" 
      v-bind:tableParameter="tableParameter" 
      v-bind:tableParameterIndex="tableParameterIndex"
      v-on:table-cell-click="onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-on:table-cell-input="onTableCellInput(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-on:table-cell-change="onTableCellChange(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-on:table-cell-custom="onTableCellCustom" />
    <span 
      v-else-if="tableParameter[tableParameterIndex].table_custom" 
      v-html="tableParameter[tableParameterIndex].table_custom(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-on:click="onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex)" />
    <span 
      v-else-if="tableParameter[tableParameterIndex].form_dropzone"
      v-html="getFileCell(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-on:click="onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex)" />
    <span 
      v-else
      v-on:click="onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex)"
      v-html="getTableCell(tableData, tableDataIndex, tableParameter, tableParameterIndex)" />

</template>

<script>

export default {
  name: "AppTableCell",
  props: ['tableData', 'tableDataIndex', 'tableParameter', 'tableParameterIndex', 'tablePage'],
  methods: {
    getFileCell(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let parameterItem = tableParameter[tableParameterIndex];
      let dataItem = tableData[tableDataIndex];
      let value = dataItem[parameterItem.key];

      // TODO kw form file HTML tag
      if(value.startsWith('http')) {
        return `<img 
                style="width: 100px"
                src="${value}" 
                />`;
        // v-bind:alt="tableData[tableDataIndex][tableParameter[tableParameterIndex].key]"
      }

      return value;
    },
    getTableCell(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let value = tableData[tableDataIndex][tableParameter[tableParameterIndex].key];
      if (!value) {
        if (tableParameter[tableParameterIndex].key.includes('.')) {
          let keys = tableParameter[tableParameterIndex].key.split('.')
          let temp = tableData[tableDataIndex]
          for (let key of keys) {
            if (temp[key]) {
              temp = temp[key]
            } else {
              temp = ''
            }
          }
          
          if (temp) {
            value = temp
          }
        }
      }
      if(value === undefined || value === null) {
        value = ''
      }
      return value
    },
    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-click', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellInput(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-input', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellChange(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      this.$emit('table-cell-change', tableData, tableDataIndex, tableParameter, tableParameterIndex);
    },
    onTableCellCustom(...args) {
      this.$emit('table-cell-custom', ...args);
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppTableCell.vue